import { BaseAppError, Opts } from '@nwwp/error'

export class CloseableError extends BaseAppError {
  override readonly kind: 'SAVE_RECORD_FAILED' | 'NETWORK_ERROR' | 'INVALID_RECORD'

  /** HTTP status of the failed Closeable response, when one was received */
  readonly statusCode?: number

  /** Raw response body of the failed Closeable response, when one was received */
  readonly responseBody?: unknown

  constructor(
    kind: CloseableError['kind'],
    message?: string,
    opts?: Opts & { statusCode?: number; responseBody?: unknown }
  ) {
    super(message ?? kind, '@nwwp/closeable', opts)
    this.kind = kind
    this.statusCode = opts?.statusCode
    this.responseBody = opts?.responseBody
  }
}
